import React from 'react';
import ProductVersion from '../../components/account/ProductVersion';
import $ from "jquery";

const Support = () => {
    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        $('#contactInfoModal').modal('hide');
    };
    return (
    <div className="Support">
        <div className="modal fade" 
            id="contactInfoModal" 
            data-backdrop="static" 
            tabIndex="-1" 
            role="dialog" 
            aria-modal="true"
            aria-labelledby="contactInfoModalTitle"
            aria-describedby="supportModalDesc"
            >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title" id="contactInfoModalTitle">Need help?</h3>
                        <button
                            type="button"
                            className="close"
                            aria-label="Close support information"
                            onClick={CloseModal}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <p id="supportModalDesc" className="sr-only">
                        Contact information and product details for customer support.
                    </p>
                        <div className="modal-content-body">
                            <div className="left-panel-sm w-full">
                                <i className="bi bi-headset b-clr" aria-hidden="true"></i>
                            </div>
                            <div className="sp-margin6">
                                <dl className="contact-list">
                                    <dt className="w-md14">Phone: </dt>
                                    <dd><a href="tel:18884709913" aria-label="Call technical support at 1-888-470-9913">1-888-470-9913</a></dd><br />
                                    <dt className="w-md14">Email: </dt>
                                    <dd>
                                        <a href="mailto:support@secureexsolutions.com" aria-label="Email support at support@secureexsolutions.com">support@secureexsolutions.com</a>
                                    </dd><br />
                                    <dt className="v-top w-md14">Product: </dt>
                                    <dd>
                                        <ProductVersion />
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={CloseModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
};

export default Support;
